<!-- <p>manage-user works!</p> -->
<div class="popop-header-outer">
    <h1>{{isEditMode ? 'Update':'Create'}} Inception Admin User</h1>
    <div class="switchbutton">
      <span class="switch-outer">
        <label class="switch">
          <input type="checkbox" [(ngModel)]="isActive" [ngModelOptions]="{standalone: true}"
          checked>
          <span class="slider round"></span>
        </label>
          {{isActive ? 'Active' : 'Inactive'}}
      </span>
    </div>

  </div>
  <form class="form" [formGroup]="form" autocomplete="off">
    <div class="card-block">
      <div class="add-new-user">
        <div class="form__group">
          <label class="form__label">First Name</label>
          <input type="text" class="form__control" formControlName="FirstName">
          <span class="error" *ngIf="hasError(formFields.FirstName, 'required')">{{validationMessages.FirstName.required}}</span>
          <span class="error" *ngIf="hasError(formFields.FirstName, 'validCharacters')">{{validationMessages.FirstName.validCharacters}}</span>
        </div>

        <div class="form__group">
          <label class="form__label">Last Name</label>
          <input type="text" class="form__control" formControlName="LastName">
          <span class="error" *ngIf="hasError(formFields.LastName, 'required')">{{validationMessages.LastName.required}}</span>
          <span class="error" *ngIf="hasError(formFields.LastName, 'validCharacters')">{{validationMessages.LastName.validCharacters}}</span>
        </div>
        <div class="form__group">
          <label class="form__label">Email</label>
          <input type="text" class="form__control" formControlName="Email">
          <span class="error" *ngIf="hasError(formFields.Email, 'required')">{{validationMessages.Email.required}}</span>
          <span class="error" *ngIf="hasError(formFields.Email, 'email')">{{validationMessages.Email.email}}</span>
        </div>

      </div>
    </div>

    <div class="button-block">
      <button class="btn-secondary" (click)="closePopup()" type="button">Cancel</button>
      <button class="btn-primary" type="submit" (click)="onSubmit()">Save</button>
    </div>
    
    <div class="loader-outer" *ngIf="loading">
      <div class="loader"></div>
    </div>
  </form>


<div class="alert" [ngClass]="messageClass ? 'success' : 'warning'" *ngIf="displayMessage">
  <p>{{message}}</p>
  <a class="close-popup" href="javascript:void(0);" (click)="closeMessagePopup()"><img width="20"
      src="assets/img/close-ic.svg"> </a>
</div>


